export const GET_PERSONS_TO_VISIT = 'GET_PERSONS_TO_VISIT';
export const IS_FETCHING = 'IS_FETCHING';
export const ERROR_SERVER = 'ERROR_SERVER';
export const SET_PERSONS_TO_VISIT = 'SET_PERSONS_TO_VISIT';
export const CLEAN = 'CLEAN';